(function () {
    'use strict';

    angular.module('swif.ui')
    .directive('swifValidationBlockUser', swifValidationBlockUser)
    .directive('swifValidationBlockAnd', swifValidationBlockAnd)
    .directive('swifValidationBlockOr', swifValidationBlockOr)
    .directive('swifValidationBlock', swifValidationBlock)
    .directive('panelValidationOrder', panelValidationOrder);


    function swifValidationBlockUser(swif) {
        'ngInject';
        return {
            restrict: 'E',
            require: 'ngModel',
            transclude: true,
            scope: {
                light: '=?',
                align: '@?'  // 'left' or 'right'
            },
            link: function (scope, element, attr, ngModel) {
                scope.proxy = {
                    selectedUser: undefined,
                    user: {},
                    user_id: false
                };
                if (!scope.align) {
                    scope.align = 'left';
                }

                ngModel.$render = function () {
                    var data = ngModel.$viewValue;
                    if (data) {
                        if (_.isNumber(data)) {
                            data = [data, ''];
                        }
                        scope.proxy.user_id = data;
                        if (data) {
                            scope.getUserFromCache(data[0]);
                        }
                    }
                };
                scope.sync = function () {
                    // ngModel.$setViewValue(scope.proxy.user_id);
                };
                scope.getUserFromCache = function (user_id) {
                    var user = swif.validation.cache.users[user_id];
                    var filter = {fields: ['name', 'service_id', 'function', 'has_image']};
                    if (!user) {
                        swif.data.get('user', user_id, filter).then(function (data) {
                            swif.validation.cache.users[data.id] = data;
                            // _.merge(scope.proxy.user, data);
                            scope.proxy.user = data;
                            scope.sync();
                        });
                    } else {
                        // _.merge(scope.proxy.user, user);
                        scope.proxy.user = user;
                        scope.sync();
                    }
                };
            },
            templateUrl: 'partials/ui/swif_validation_block_user.html'
        };
    }


    function swifValidationBlockAnd(swif) {
        'ngInject';
        var ret = angular.copy(swif.validation.defaultDirective);
        // 'counter' is used to ensure color consistency (group colors on it),
        // can reference the validation (or 'next' block) object
        ret.scope.counter = '=?';
        ret.templateUrl = 'partials/ui/swif_validation_block_and.html';
        ret.link = function (scope, element, attr, ngModel) {
            swif.validation.defaultDirective.link(scope, element, attr, ngModel);
            scope.operator = 'and';
            var originalRender = ngModel.$render;
            scope.ensureOnetLineExists = function () {
                if (scope.proxy.items.length === 0 && scope.initialize) {
                    scope.addItem();
                }
            };

            ngModel.$render = function () {
                originalRender();
                var data = ngModel.$viewValue || [];
                scope.ensureOnetLineExists();
            };

            scope.$watch('proxy.items', function (newV, oldV) {
                if (!angular.equals(newV, oldV) && newV) {
                    scope.sync();
                    scope.ensureOnetLineExists();
                }
            }, true);
        };
        return ret;

    }

    function swifValidationBlockOr(swif) {
        'ngInject';
        var ret = angular.copy(swif.validation.defaultDirective);
        ret.scope.counter = '=?';
        ret.transclude = true;
        ret.templateUrl = 'partials/ui/swif_validation_block_or.html';
        ret.link = function (scope, element, attr, ngModel) {
            swif.validation.defaultDirective.link(scope, element, attr, ngModel);
            scope.currentUser = swif.user.getAuthenticatedUserData();
            scope.color = swif.validation.getNextColor(scope.counter || {});
            scope.operator = 'or';
            scope.proxy.hasValue = scope.proxy.items.length > 0 ? true: undefined;

            var originalAddItem = scope.addItem;
            scope.addItem = function (model) {
                var user_id = model.user_id ? model.user_id[0]: 0;
                if (scope.currentUser.id === user_id) {
                    model._choice = model.state || 'active';
                }
                originalAddItem(model);
            };

            var originalRender = ngModel.$render;
            ngModel.$render = function () {
                originalRender();
                _.forEach(scope.proxy.items, function (item) {
                    var user_id = item.user_id ? item.user_id[0]: 0;
                    if (scope.currentUser.id === user_id) {
                        item._choice = item.state || 'active';
                    }
                });
            };

            scope.$watch('proxy.selectedUser', function (newV) {
                if (newV) {
                    var newBlock = {user_id: newV, note: ''};
                    scope.addItem(newBlock);
                    delete scope.proxy.selectedUser;
                }
            });

            scope.$watchCollection('proxy.items', function (newV, oldV) {
                // for now, proxy.items is initialized empty Array,
                // but when populated, newV === oldV (why ?), so the angular.equals
                // returns false (that's why i compute hasValue outside of angular.equals())
                if (_.isArray(newV)) {
                    scope.proxy.hasValue = newV.length > 0 ? true: undefined;
                }
                if (!angular.equals(newV, oldV) && newV) {
                    scope.sync();
                }
            }, true);
        };
        return ret;
    }

    // this is the main directive used to fill a validation wkf,
    // it uses a "next" block by its own, where each element is an "and" block
    // it allows to move up and down its items, and allow to create new elements
    function swifValidationBlock(swif) {
        'ngInject';
        var ret = angular.copy(swif.validation.defaultDirective);
        ret.templateUrl = 'partials/ui/swif_validation_block_next.html';
        ret.link = function (scope, element, attr, ngModel) {
            swif.validation.defaultDirective.link(scope, element, attr, ngModel);
            scope.operator = 'next';

            var originalRender = ngModel.$render;
            ngModel.$render = function () {
                originalRender();
                var data = ngModel.$viewValue || [];
                scope.counter = data;
                swif.validation.resetColors(data);
                if (data.items.length === 0 && scope.initialize) {
                    scope.addItem();
                }
            };

            scope.moveUp = function (item) {
                var index = scope.proxy.items.indexOf(item);
                if (index > 0) {
                    scope.proxy.items.splice(index, 1);
                    scope.proxy.items.splice(index - 1, 0, item);
                }
            };

            scope.moveDown = function (item) {
                var index = scope.proxy.items.indexOf(item);
                if (index < scope.proxy.items.length - 1) {
                    scope.proxy.items.splice(index, 1);
                    scope.proxy.items.splice(index + 1, 0, item);
                }
            };

            scope.$watch('proxy.items', function (newV, oldV) {
                if (!angular.equals(newV, oldV) && newV) {
                    scope.sync();
                }
            }, true);
        };
        return ret;
    }

    function panelValidationOrder(swif) {
        'ngInject';
        var linked = function (scope) {
            if (scope.item) {
                if (scope.item.state === 'active') {
                    scope.blocks = swif.validation.getGroupedItems(scope.item);
                } else if (_.contains(['confirm', 'refuse'], scope.item.state)) {
                    scope.blocks = swif.validation.getLastItem(scope.item);
                }
            }
        };
        var directive = swif.panel.create_directive('validation-order', undefined, linked);
        directive.templateUrl = 'partials/ui/panel_validation_wkf.html';
        return directive;
    }

})();
